import { create, get, listar, listarEventosDisponiveis, remove, testar, update } from '@/api/webhook'
import { FormWebhook } from '@/models'
import { WebhookServiceAdapter } from '@/usecases'

export class WebhookService implements WebhookServiceAdapter {
	listar = async () => await listar()
	get = async (id: string) => await get(id)
	create = async (webhook: FormWebhook) => await create(webhook)
	update = async (webhook: FormWebhook) => await update(webhook)
	delete = async (id: string) => remove(id)
	testar = async (id: string) => testar(id)
	listarEventosDisponiveis = async () => await listarEventosDisponiveis()
}
